"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const KeyboardArrowRight_1 = __importDefault(require("@material-ui/icons/KeyboardArrowRight"));
const ImageRounded_1 = __importDefault(require("@material-ui/icons/ImageRounded"));
const styles = {
    root: {
        cursor: 'pointer',
        flexGrow: 1,
    },
    boardImage: {
        maxWidth: '34px',
    },
    boardListItemHeader: {
        color: '#39A9B0',
    },
    boardListItemIcon: {
        fontSize: '36px',
    },
    boardListItemWrapper: {
        padding: '10px',
        marginBottom: '10px',
    },
};
const BoardListItem = (props) => {
    const { boardName, classes, imageBase64, imageMime, linkTo, reviewCount } = props;
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Paper, { elevation: 2, className: classes.boardListItemWrapper, variant: "elevation" },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, alignItems: "center", onClick: linkTo },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 2, sm: 1 },
                    react_1.default.createElement(core_1.Grid, { container: true, justify: "center" }, (imageBase64 === null || imageBase64 === void 0 ? void 0 : imageBase64.length) > 0 ? (react_1.default.createElement("img", { alt: boardName, src: `data:${imageMime};base64,${imageBase64}`, className: classes.boardImage })) : (react_1.default.createElement(ImageRounded_1.default, { className: classes.boardListItemIcon })))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 8, sm: 10 },
                    react_1.default.createElement(core_1.Typography, { variant: "subtitle1", className: classes.boardListItemHeader }, boardName),
                    react_1.default.createElement(core_1.Typography, { variant: "subtitle2", color: "textSecondary" },
                        reviewCount,
                        " Active Reviews")),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 2, sm: 1 },
                    react_1.default.createElement(KeyboardArrowRight_1.default, { className: classes.boardListItemIcon }))))));
};
BoardListItem.propTypes = {
    boardName: prop_types_1.default.string.isRequired,
    classes: prop_types_1.default.object.isRequired,
    imageBase64: prop_types_1.default.string,
    imageMime: prop_types_1.default.string,
    linkTo: prop_types_1.default.func.isRequired,
    reviewCount: prop_types_1.default.number.isRequired,
};
exports.default = styles_1.withStyles(styles)(BoardListItem);
